<app-question-card>
  <p question>How soon are you looking to sell?</p>
  <div class="form-field" input-options>
    <div class="radio-option-arrow">
      <input
        type="radio"
        [id]="SaleTimelineLabel.ASAP"
        name="sell-timeline"
        [value]="SaleTimeline.ASAP"
        [(ngModel)]="saleTimeline"
        (click)="submit(SaleTimeline.ASAP)"
      />
      <label [for]="SaleTimelineLabel.ASAP">
        {{SaleTimelineLabel.ASAP}}
        <app-icon class="ml-auto" color="var(--color-primary)" fontWeight="100" fontSize="32">right</app-icon>
      </label>
    </div>
    <div class="radio-option-arrow">
      <input
        type="radio"
        [id]="SaleTimelineLabel.LT3M"
        name="sell-timeline"
        [value]="SaleTimeline.LT3M"
        [(ngModel)]="saleTimeline"
        (click)="submit(SaleTimeline.LT3M)"
      />
      <label [for]="SaleTimelineLabel.LT3M">
        {{SaleTimelineLabel.LT3M}}
        <app-icon class="ml-auto" color="var(--color-primary)" fontWeight="100" fontSize="32">right</app-icon>
      </label>
    </div>
    <div class="radio-option-arrow">
      <input
        type="radio"
        [id]="SaleTimelineLabel.B3TO6M"
        name="sell-timeline"
        [value]="SaleTimeline.B3TO6M"
        [(ngModel)]="saleTimeline"
        (click)="submit(SaleTimeline.B3TO6M)"
      />
      <label [for]="SaleTimelineLabel.B3TO6M">
        {{SaleTimelineLabel.B3TO6M}}
        <app-icon class="ml-auto" color="var(--color-primary)" fontWeight="100" fontSize="32">right</app-icon>
      </label>
    </div>
    <div class="radio-option-arrow">
      <input
        type="radio"
        [id]="SaleTimelineLabel.B6TO12M"
        name="sell-timeline"
        [value]="SaleTimeline.B6TO12M"
        [(ngModel)]="saleTimeline"
        (click)="submit(SaleTimeline.B6TO12M)"
      />
      <label [for]="SaleTimelineLabel.B6TO12M">
        {{SaleTimelineLabel.B6TO12M}}
        <app-icon class="ml-auto" color="var(--color-primary)" fontWeight="100" fontSize="32">right</app-icon>
      </label>
    </div>
    <div class="radio-option-arrow">
      <input
        type="radio"
        [id]="SaleTimelineLabel.NA"
        name="sell-timeline"
        [value]="SaleTimeline.NA"
        [(ngModel)]="saleTimeline"
        (click)="submit(SaleTimeline.NA)"
      />
      <label [for]="SaleTimelineLabel.NA">
        {{SaleTimelineLabel.NA}}
        <app-icon class="ml-auto" color="var(--color-primary)" fontWeight="100" fontSize="32">right</app-icon>
      </label>
    </div>
  </div>
  <p class="chat-answer" answer>{{SaleTimelineLabel[saleTimeline!]}}</p>
</app-question-card>
